
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5 6a13.41 13.41 0 00-9.546 3.954A13.412 13.412 0 007 19.5c0 3.606 1.404 6.996 3.954 9.546A13.41 13.41 0 0020.5 33c3.605 0 6.995-1.404 9.545-3.954A13.412 13.412 0 0034 19.5c0-3.606-1.404-6.996-3.954-9.546A13.411 13.411 0 0020.5 6zm0-2C29.06 4 36 10.94 36 19.5 36 28.06 29.06 35 20.5 35 11.94 35 5 28.06 5 19.5 5 10.94 11.94 4 20.5 4z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.176 19.105l-5.831-5.832 1.414-1.414 7.245 7.246-7.245 7.246-1.414-1.414 5.831-5.832z"}})])
          )
        }
      }
    